import { useEffect } from 'react';
import GlobalProviders from '../context/GlobalProviders';
import ContentCheckout from '../components/Slides/ContentCheckout';

export default function CheckoutPage({ onMount }) {
  useEffect(() => {
    if (onMount) onMount();
  }, [onMount]);

  return (
    <GlobalProviders>
      <ContentCheckout />
    </GlobalProviders>
  );
}
